import React from "react";
import EiaLink from "../../components/tables/EiaLink";

const getLink = function (amount, name, link) {
    const label = amount ? amount + " x " + name : name;

    return <EiaLink name={label} link={link} isExternal={true} />
}

export const grandRuby = function (amount) {
    return getLink(amount, "Grand Ruby", "https://www.wowhead.com/diablo-4/item/grand-ruby-315738");
}

export const grandSkull = function (amount) {
    return getLink(amount, "Grand Skull", "https://www.wowhead.com/diablo-4/item/grand-skull-2059554");
}

export const grandTopaz = function (amount) {
    return getLink(amount, "Grand Topaz", "https://www.wowhead.com/diablo-4/item/grand-topaz-315756");
}

export const grandEmerald = function (amount) {
    return getLink(amount, "Grand Emerald", "https://www.wowhead.com/diablo-4/item/grand-emerald-315730");
}

export const grandSapphire = function (amount) {
    return getLink(amount, "Grand Sapphire", "https://www.wowhead.com/diablo-4/item/grand-sapphire-315745");
}

export const grandAmethyst = function (amount) {
    return getLink(amount, "Grand Amethyst", "https://www.wowhead.com/diablo-4/item/grand-amethyst-315721");
}










